export default "__VITE_ASSET__CHfi7nE2__"